export default __webpack_public_path__ + "static/media/resource-benefits.79477baf.svg";